export const TOKEN_KEY = 'bgh_access_token';
export const REFRESH_KEY = 'bgh_refresh_token';
export const AUTH_USER_KEY = 'hotel_auth_user';
export const AUTH_ROLE_KEY = 'hotel_authenticated_role';
export const AUTH_PERMISSIONS_KEY = 'hotel_auth_permissions';
